import { ConfigType } from '../utils/requestAPI';

type GetUsersParamsType = {
  page?: number;
  limit?: number;
  search?: string;
  role?: string;
};

const adminApi = {
  getAllUsers: (): ConfigType => {
    return {
      url: '/auth',
      method: 'get',
    };
  },

  getUserByRole: (params: GetUsersParamsType): ConfigType => {
    return {
      url: '/auth',
      method: 'get',
      params,
      config: {
        store: {
          action: 'set',
          key: 'clientData.data',
        },
      },
    };
  },
  getSingleUser: (id: string): ConfigType => {
    return {
      url: `/auth/user/${id}`,
      method: 'get',
      config: {
        store: {
          action: 'set',
          key: 'singleClientData',
        },
      },
    };
  },
  getDepartmentUsers: (params?: GetUsersParamsType): ConfigType => {
    return {
      url: '/auth/department-users',
      method: 'get',
      params,
      config: {
        store: {
          action: 'set',
          key: 'departmentUsersData.data',
        },
      },
    };
  },
};

export default adminApi;
